import React from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import { WarmupProvider, useWarmup } from './contexts/WarmupContext';
import AppRoutes from './routes/AppRoutes';
import Navbar from './components/Layout/Navbar';
// import ServiceWarmup from './components/ServiceWarmup';
import AuthDebug from './components/Debug/AuthDebug';
import { Analytics } from "@vercel/analytics/react"
import './App.css';

// Create Material-UI theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#6e34c2',
      light: '#9a67d8',
      dark: '#4a148c',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#ec7e21',
      light: '#ff9f52',
      dark: '#b55000',
      contrastText: '#ffffff',
    },
    background: {
      default: '#fafafa',
      paper: '#ffffff',
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.6)',
    },
  },
  typography: {
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
    },
  },
});

// Main App Content Component
const AppContent: React.FC = () => {
  // const { isWarmupComplete, setWarmupComplete } = useWarmup();
  const location = useLocation();
  
  // Routes where Navbar should not be displayed
  const routesWithoutNavbar = ['/documentation'];
  const shouldShowNavbar = !routesWithoutNavbar.includes(location.pathname);

  // if (!isWarmupComplete) {
  //   return <ServiceWarmup onWarmupComplete={setWarmupComplete} />;
  // }

  return (
    <Box sx={{ display: 'flex' }}>
      {/* <AuthDebug /> */}
      {shouldShowNavbar && <Navbar />}
      <AppRoutes />
    </Box>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <WarmupProvider>
        <AuthProvider>
          <Router>
            <AppContent />
            <Analytics />
          </Router>
        </AuthProvider>
      </WarmupProvider>
    </ThemeProvider>
  );
}

export default App;
